import { useStaticQuery, graphql } from "gatsby"

export const useSectionNewsData = () => {
  const data = useStaticQuery(graphql`
    query newsQuery {
      allContentfulArticle {
        nodes {
          title
          published
          banner {
            gatsbyImageData
            url
          }
        }
      }
    }
  `)

  return data.allContentfulArticle
}
